import { useSetRecoilState } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { formDialogAtom } from '../recoil';
export function useI18nFormDialog() {
    const { t } = useTranslation();
    const setFormDialog = useSetRecoilState(formDialogAtom);
    const setI18nDialog = (i18n, props) => {
        const prefix = `cms:dialog.${i18n}.`;
        const vars = props.i18nVariables ?? {};
        const i18nProps = {
            title: t(`${prefix}title`, vars),
            description: t(`${prefix}description`, vars),
            cancelText: t(`${prefix}cancelText`, vars),
            continueText: t(`${prefix}continueText`, vars),
        };
        setFormDialog({
            ...i18nProps,
            ...props,
        });
    };
    return setI18nDialog;
}
